module.exports = __webpack_public_path__ + "img/pinterest.47b5b690.svg";